import { Layout } from 'antd';
import { FC, useState } from 'react';
import { Footer } from './Footer';
import { CustomHeader } from './CustomHeader';
import { PreHeader } from './PreHeader';
import { MenuMock } from '../../mocks/MenuMock';
import { MenuMobile } from './MenuMobile';


const { Content } = Layout;

const AppShell: FC<{}> = (props) => {


  const [open, setOpen] = useState(false);
  const showDrawer = (isOpen: boolean) => {
    setOpen(!isOpen);
  };

  return (
    <>
      <PreHeader></PreHeader>
      <Layout className='Layout'>
        <CustomHeader open={open} showDrawer={showDrawer}></CustomHeader>
        <MenuMobile open={open} ></MenuMobile>
        <Content>
          <div className="site-layout-content" >
            {
              MenuMock.items.map((_, index) => (

                <div key={index} id={`single-spa-application:${_.spaName}`}></div>
              ))
            }
          </div>
        </Content>
        <Footer />
      </Layout>

    </>

  )
};

export default AppShell